<template>
  <WhiteModal
    :title="$t('add_custom_package.title')"
    :subtitle="$t('add_custom_package.subtitle')"
    :bodyClass="'custom-package-modal-body'"
    @close="$emit('close')"
  >
    <div class="gap-row-1xs">
      <div class="dish-info-header gap-column-xs">
        <div class="dish-name gap-row-zero w-100">
          <div class="w-100 qrw-label-sm bold v1-grey-6-color">
            {{ dish.category }}
          </div>
          <div class="w-100 qrw-heading-md bold v1-grey-10-color">
            {{ dish.name }}
          </div>
        </div>

        <div class="dish-price gap-row-zero w-100">
          <div class="w-100 qrw-label-sm bold v1-grey-6-color">
            {{ $t("add_custom_package.price") }}
          </div>
          <div class="w-100 qrw-heading-md v1-grey-10-color">
            {{ Math.round(totalPrice * 100) / 100 }}{{ currency.symbol }}
          </div>
        </div>

        <div class="dish-weight gap-row-zero w-100">
          <div class="w-100 qrw-label-sm bold v1-grey-6-color">
            {{ $t("add_custom_package.total_weight") }}
          </div>
          <div class="w-100 qrw-heading-md v1-grey-10-color">
            {{ Math.round(totalWeight * 100) / 100 }} {{ dish.unit }}
          </div>
        </div>
      </div>

      <BaseDivider color="v1-grey-8" />
    </div>

    <div class="modifications-grid">
      <PackagingModificatorsGroup
        class="mods-grid-card"
        v-for="(pg, index) in dish.price_groups"
        v-model="dish_config[index]"
        :price_group="pg"
        :key="pg._id"
      />
    </div>

    <template #footer>
      <div
        class="unique-warning w-100"
        :style="{
          visibility: isDishConfigUnique ? 'hidden' : 'visible',
        }"
        v-show="!isDishConfigUnique"
      >
        <BaseIcon icon="allert" size="xs" />
        {{ $t("add_custom_package.combination_exists") }}
      </div>

      <BaseInput
        fullWidth
        v-model="packaging_name"
        :placeholder="$t('add_custom_package.name_ph')"
        v-if="isDishConfigUnique"
      />

      <BaseSelect
        v-model="selected_packaging_id"
        fullWidth
        class="w-100"
        v-if="isDishConfigUnique"
      >
        <option :value="null" disabled>
          {{ $t("add_custom_package.package_ph") }}
        </option>
        <option v-for="pkg in packagings" :value="pkg._id" :key="pkg._id">
          {{ pkg.name }} ({{ pkg.price }}{{ currency.symbol }})
        </option>
      </BaseSelect>

      <BaseButton
        class="nowrap"
        icon="plus-bold"
        bold
        variant="primary"
        size="md"
        color="green-5"
        @click="addCustomPackage"
        :disabled="
          !isDishConfigUnique || !selected_packaging_id || !packaging_name
        "
      >
        {{ $t("add_custom_package.btn_add") }}
      </BaseButton>
    </template>
  </WhiteModal>
</template>

<script>
import PackagingModificatorsGroup from "@/components/menu/PackagingModificatorsGroup.vue";

export default {
  props: {
    dish: Object,
    dishConfigs: Array,
    packagings: Array,
  },
  data() {
    return {
      dish_config: [],

      selected_packaging_id: null,

      totalPrice: 0,
      totalWeight: 0,
      packaging_name: null,
    };
  },
  watch: {
    dish_config: {
      deep: true,
      handler() {
        this.calculateWeightAndPrice();
      },
    },
  },
  methods: {
    calculateWeightAndPrice() {
      this.totalPrice = this.dish.base_price;
      this.totalWeight = this.dish.base_weight || 0;

      for (let i = 0; i < this.dish_config.length; i++) {
        const cfg_group = this.dish_config[i];

        for (const mod_id of cfg_group) {
          const modificator = this.dish.price_groups[i].items.find(
            (pgi) => pgi._id == mod_id
          );

          if (modificator) {
            this.totalPrice += modificator.price || 0;
            this.totalWeight += modificator.weight || 0;
          }
        }
      }
    },
    addCustomPackage() {
      this.$emit("add", {
        name: this.packaging_name,
        packaging_id: this.selected_packaging_id,
        modificator_ids: this.currentConfig,
      });
    },
  },
  computed: {
    currentConfig() {
      return this.dish_config.flat();
    },
    isDishConfigUnique() {
      return !this.dishConfigs.find((cfg) => {
        const cfgSet = new Set(cfg);

        return (
          cfgSet.size == this.currentConfig.length &&
          this.currentConfig.every((id) => cfgSet.has(id))
        );
      });
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  created() {
    this.dish_config = this.dish.price_groups.map((pg) => {
      if (pg.min_count) {
        return pg.items.slice(0, pg.min_count).map((pgi) => pgi._id);
      } else {
        return [];
      }
    });

    this.calculateWeightAndPrice();
  },
  components: {
    PackagingModificatorsGroup,
  },
};
</script>

<style scoped>
.unique-warning {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  column-gap: 8px;

  color: var(--orange-4-color);
}

.modifications-grid {
  width: 100%;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 24px;
  display: flex;
}

.mods-grid-card {
  width: 100%;
  flex: 1 1 calc(33% - 16px);
}
</style>

<style>
.custom-package-modal-body {
  row-gap: 16px !important;
  padding: 16px 24px !important;
}
</style>